'use strict';

// based on http://stackoverflow.com/questions/5916900/detect-version-of-browser

var _browserName = '',
    _version = 0;

var _isMobile = typeof navigator !== 'undefined'
  ? /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())
  : false;

function getBrowserNameAndVersion() {

  if (typeof navigator === 'undefined') {
    console.log('navigator is not available in node');
    return {
      name: 'Chrome',
      version: 0
    };
  }

  var ua = navigator.userAgent,
      versionMatch,
      match = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

  if (/trident|msie/i.test(match[1])) {
    versionMatch = /\brv[ :]+(\d+)/g.exec(ua) || /\bMSIE[ :]+(\d+)/g.exec(ua) || [];
    return {
      name: 'IE',
      version: parseInt(versionMatch[1] || 0, 10)
    };
  }

  if (match[1] === 'Chrome') {
    versionMatch = ua.match(/\bOPR\/(\d+)/);
    if (versionMatch !== null) {
      return {
        name: 'Opera',
        version: parseInt(versionMatch[1] || 0, 10)
      };
    }
  }

  match = match[2] ?
    [match[1], match[2]] :
    [navigator.appName, navigator.appVersion, '-?'];

  if ((versionMatch = ua.match(/version\/(\d+)/i)) !== null) {
    match.splice(1, 1, versionMatch[1]);
  }

  return {
    name: match[0],
    version: parseInt(match[1] || 0, 10)
  };
}

try {
  var data = getBrowserNameAndVersion();
  _browserName = data.name;
  _version = data.version;
} catch (err) { }

module.exports = {
  getBrowserName: () => _browserName,
  getVersion: () => _version,
  isIE: () => _browserName === 'IE',
  isIE10: () => _browserName === 'IE' && _version === 10,
  isChrome: () => _browserName === 'Chrome',
  isFirefox: () => _browserName === 'Firefox',
  isOpera: () => _browserName === 'Opera',
  isMobile: () => _isMobile
};



/** WEBPACK FOOTER **
 ** ./utils/Browser.js
 **/